<template>
  <div class="Details">
     <section>
        <div class="x">
          <div class="box" v-if="!project.modelId">
            <h4 class="title is-4">Not deployed yet. Run your AI model training first</h4>
          </div>
           <div class="box" v-else>
            <DeployMonitor :project="project"/>
           </div>
        </div>
     </section>
  </div>
</template>
<script>
import DeployMonitor from '@/components/DeployMonitor.vue'
import ModelRuns from "@/components/TrainRuns.vue";

import Papa from 'papaparse'
  
   export default {
     props: ["project", "dataset", "currentUser", "tabId", "rows"],
     name: "Inference",
     data: function() {
    return {
        model_url: 'https://api.metatext.ai/inference/' + this.project.id,
        model_url_batch: 'https://api.metatext.ai/inference-batch/' + this.project.id,
        model_hub_url: 'https://api.metatext.ai/hub-inference/' + this.project.id,
        deployment_model_base_url: 'https://api.metatext.ai/v1/inference/',
        deployment_answering_model_base_url: 'https://api.metatext.ai/v1/answering/',
        deployment_generation_model_base_url: 'https://api.metatext.ai/v1/generation/',
        api_key: 'YOUR_API_KEY',
        apiKeyPlaceholder: 'YOUR_API_KEY',
        all_users_api_key: 'GcD8CJgm1i4ELinYrXLbt4pAMi5gXptN9FuB5MwI',
        text: "",
        result: '',
        isLoading: false,
        tabItem: 'training',
      }},
      
      components: {
        DeployMonitor,
        ModelRuns
      },
     computed: {
       items() {
         return this.$store.state.currentModelItems;
       }
     },
     methods: {
         getApiKey(){
            if(this.currentUser && "apiKey" in this.currentUser && this.currentUser.apiKey != undefined){
              return this.currentUser.apiKey
            } else {
              return this.all_users_api_key
            }
         },
         getInferenceUrl() {
            let endpoint_name = this.project.type == 'classification'?'inference':this.project.type
            let endpoint_version = this.project.type == 'classification'?'v1.1':'v1'
            return `https://api.metatext.ai/${endpoint_version}/${endpoint_name}/${this.project.id}`
         },
         copyURL(data) {
            
            data.select();
            document.execCommand("copy");
        },
    },
        
     created() {
        
       this.training = true
       this.options = {},
       this.currentTab = "details"
       this.$store.dispatch("projectModels", this.project.models)
     }
   };
</script>
<style lang="scss" scoped>
pre {
    white-space: pre-wrap;
}
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  .board {
  cursor: pointer;
  border: solid 1px #e6e4e4;
  border-radius: 4px;
  &:hover {
  background: #fafafa;
  }
  .info {
  padding: 16px;
  .name {
  display: block;
  margin-bottom: 8px;
  text-transform: capitalize;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  }
  .description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  margin-bottom: 8px;
  overflow: hidden;
  }
  }
  }
  }
</style>